import { Injectable } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  key = environment.googleAnalytics.key;
  constructor() {
  }
  public logPageView(event: NavigationEnd) {
    if (this.key === '') {
      return;
    }

    gtag('config', this.key,
      {
        'page_path': event.urlAfterRedirects
      }
    );
  }

  public eventEmitter(
    eventName: string,
    eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null) {
    gtag('event', eventName, {
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      eventAction: eventAction,
      eventValue: eventValue
    });
  }
}
